import { assign, find } from 'lodash'

import HTTP from '@/common/HTTP'
import { actionTypes as draftActionTypes } from './DraftsTypes'
import { actionTypes, mutationTypes } from './SurveysTypes'
import { actionTypes as globalActionTypes } from './GlobalTypes'


function initialState() {
  return {
    surveys: [],
    selectedSurvey: null,
    snackbarObj: null,
  }
}

const mutations = {
  [mutationTypes.SET_SURVEYS](state, items) {
    state.surveys = items
  },

  [mutationTypes.REPLACE_SURVEY](state, survey) {
    assign(find(state.surveys, { id: survey.id }), survey)
  },

  [mutationTypes.SET_SELECTED_SURVEY](state, survey) {
    state.selectedSurvey = survey
  },

}

const actions = {
  async [actionTypes.FETCH_SURVEYS]({ state, commit }) {
    const { data: { content } } = await HTTP.get('/surveys?sort=created,desc')
    commit(mutationTypes.SET_SURVEYS, content)
    return state
  },

  async [actionTypes.FETCH_SURVEY]({ commit, dispatch }, id) {
    const { data } = await HTTP.get(`/surveys/${id}`)
    commit(mutationTypes.SET_SELECTED_SURVEY, data)
    return data
  },

  async [actionTypes.CREATE_SURVEY]({ commit, dispatch }, survey) {
    const { data } = await HTTP.post('/surveys', survey)
    dispatch(globalActionTypes.SHOW_SNACKBAR, { message: 'Fragebogen wurde erfolgreich erstellt' }, { root: true })
    return data
  },

  async [actionTypes.EDIT_SURVEY]({ commit, dispatch }, survey) {
    const { data } = await HTTP.patch(`/surveys/${survey.id}`, survey)
    commit(mutationTypes.SET_SELECTED_SURVEY, data)
    commit(mutationTypes.REPLACE_SURVEY, data)
    dispatch(globalActionTypes.SHOW_SNACKBAR, { message: 'Änderungen wurden erfolgreich gespeichert' }, { root: true })
    return data
  },

  async [actionTypes.COPY_SURVEY]({ commit, dispatch }, survey) {
    const oldSurvey = await dispatch(actionTypes.FETCH_SURVEY, survey.id)
    const oldDraft = await dispatch(`Drafts/${draftActionTypes.FETCH_DRAFT}`, survey.id, { root: true })
    const newSurvey = await dispatch(actionTypes.CREATE_SURVEY, {
      name: `Kopie von ${oldSurvey.name}`,
      description: oldSurvey.description
    })
    await Promise.all(oldDraft.questionGroups.map(group =>
      dispatch(`Drafts/${draftActionTypes.CREATE_GROUP}`, {
        survey: newSurvey,
        questionGroup: {
          title: group.title,
          description: group.description,
          position: group.position
        },
        questions: group.questions
      }, { root: true })
    ))

    // TODO fix available options
    dispatch(actionTypes.FETCH_SURVEYS)
    dispatch(actionTypes.FETCH_SURVEY, newSurvey.id)
    return newSurvey
  },


  async [actionTypes.DELETE_SURVEY]({ commit, dispatch }, survey) {
    try {
      await HTTP.delete(`/surveys/${survey.id}`)
      dispatch(actionTypes.FETCH_SURVEYS)
    } catch (e) {
      dispatch(globalActionTypes.SHOW_SNACKBAR, {
        message: 'Fragebogen konnte nicht gelöscht werden, da er in einem Audit verwendet wird.',
        color: 'error'
      }, { root: true })
    }
  },
}

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Surveys.js